import React, { MouseEvent } from 'react';
import { useStringsContext } from '../../../contexts/strings';
import LoadingButton from '@mui/lab/LoadingButton';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SceneHeader from '../../common/scene/scene-header';

interface Props {
  onSubmit: (e: MouseEvent) => void;
  isSubmitting: boolean;
  isDisabled: boolean;
}

const AppDetailsHeader = ({ onSubmit, isSubmitting, isDisabled }: Props) => {
  const { strings } = useStringsContext();

  return (
    <SceneHeader title={strings.menu.appMenu}>
      <LoadingButton
        onClick={onSubmit}
        type="submit"
        variant="contained"
        color="primary"
        startIcon={<CloudUploadIcon />}
        loading={isSubmitting}
        disabled={isDisabled}
      >
        {strings.actions.publishChanges}
      </LoadingButton>
    </SceneHeader>
  );
};

export default AppDetailsHeader;
